<template>
  <div
    class="contenedorTarjetaNuevasMomento"
    v-bind:class="{ banderaSeguimiento : banderaSeguimiento, banderaTarjetaMiniaturaExpandible : banderaTarjetaMiniaturaExpandible }"
  >
    <v-card v-if="getVariablesFormularios && getVariablesFormularios.length!=0" id="tarjetaResumen" class="tarjeta">
      <v-form ref="formOverlay" v-model="valid" lazy-validation>
        <div class="tituloVariable" v-if="texto_introductorio">
          <p style="text-align: justify" class="mt-3 mb-0 pr-3" v-html="texto_introductorio">
          </p>
        </div>
        <v-container class="grid container" v-bind:style="{gridTemplateColumns:gridTemplate}">
          <div
            v-if="variableF.visible"
            v-for="(variableF, index5) in getVariablesFormularios"
            :key="index5"
          >
            <div
              id="DivInformacionResumen" class="pb-0"
              v-bind:style="[ variableF.tipo!='fecha'? { padding:padding } : {padding:padding}]"
            >
              <label v-if="variableF.visible"  class="tituloVariable" v-html="variableF.nombre"></label>
              <v-tooltip top max-width="300px">
                <template v-slot:activator="{ on }">
                  <date-picker
                    v-if="variableF.tipo=='fecha'"
                    :obligatorio="variableF.key === 'fecha_nacimiento' ? true : variableF.obligatorio"
                    :reglasObligatorio="reglasObligatorio"
                    v-model="getVariablesFormularios[index5].valor"
                    label=""
                    v-on="on"
                    :deshabilitado="deshabilitado"
                  />
                  <v-autocomplete
                    :disabled="deshabilitado"
                    v-else-if="variableF.tipo=='lista'"
                    v-model="getVariablesFormularios[index5].valor"
                    v-on="on"
                    :rules="variableF.obligatorio? reglasObligatorio:[]"
                    :items="variableF.opciones_lista"
                    item-text="valor" class="autocomplete"
                    dense rounded
                  ></v-autocomplete>
                  <v-text-field
                    :disabled="deshabilitado"
                    v-else-if="variableF.tipo=='numero'"
                    v-model="getVariablesFormularios[index5].valor"
                    v-on="on"
                    type="number"
                    :rules="variableF.obligatorio? reglasObligatorio:[]"
                    required class="inputNumero"
                    dense rounded
                  ></v-text-field>
                  <template v-else-if="variableF.tipo === 'lista_radio_button'">
                    <h3 class="nombreRadioGroup" v-html="variableF.nombre"></h3>
                    <v-radio-group v-model="getVariablesFormularios[index5].valor" :disabled="deshabilitado" row>
                      <v-radio color="primary" v-for="(opcionRadioButton, index3) in variableF.opciones_lista"
                          :key="index3" :label="opcionRadioButton.valor" :value="opcionRadioButton.valor">
                      </v-radio>
                    </v-radio-group>
                  </template>
                  <v-textarea
                    :disabled="deshabilitado"
                    rows="1"
                    auto-grow
                    v-else
                    v-model="getVariablesFormularios[index5].valor"
                    v-on="on"
                    :rules="variableF.obligatorio? reglasObligatorio:[]"
                    required
                    class="inputTexto" rounded dense
                  ></v-textarea>
                  <!-- <youtube v-if="variableF.multimedia" :video-id="variableF.multimedia" ref="youtube" @playing="playing(index5)"></youtube> -->
                </template>
                <span v-html="variableF.nombre"></span>
              </v-tooltip>
              <v-tooltip v-if="variableF.imagenAyuda" bottom max-width="500px">
                <template v-slot:activator="{ on }">
                  <v-icon color="warning" v-on="on">info</v-icon>
                </template>
                <span>
                  <img :src="variableF.imagenAyuda" alt="avatar" />
                </span>
              </v-tooltip>
            </div>
          </div>
        </v-container>
      </v-form>
      <div
        v-if="getVariablesFormularios!=[] && deshabilitado==false"
        class="contenedorBotones"
        style="position: initial; width: 100%; justify-content: flex-end;"
      >
        <button @click="construirArrayVariablesActualizar()" type="button" id="BotonGuardar" class="botones elevation-3">Guardar</button>
        <button
          type="button"
          v-if="borrable"
          id="botonEliminar"
          class="botones elevation-3"
        >Eliminar</button>
      </div>
    </v-card>
  </div>
</template>
<script>
import metodos_comunes from "../../js/metodos_comunes";
import { actualizarFormulario } from "../../apiService/request/CrudFormulario.js";
import { eliminarFormulariosExistentes } from "../../apiService/request/CrudFormulario";
import { serverBus } from "../../main";
import moment from "moment";
import DatePicker from "../DatePicker/Datepicker";
import { crearOrdenDesdeFormulario } from "../../apiService/request/CrudOrdenes";
// import Vue from 'vue'
// import VueYoutube from 'vue-youtube'

// Vue.use(VueYoutube)

// import metodos_comunes from '../../js/metodos_comunes'
export default {
  data() {
    return {
      nombreFormulario: null,
      idFormulario: null,
      variablesFormulario: null,
      coleccion: null,
      valorVariable: 0,
      padding: "2% 3% 2% 3%",
      gridTemplate: "1fr 1fr 1fr",
      valid: false,
      reglasObligatorio: [v => !!v || "Campo obligatorio"],
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      variablesActualizadas: [],
      cargandoComponente: true,
      options: {
        locale: "es",
        format: "YYYY/MM/DD",
        clearable: true
      },

      responsive: "embed-responsive-item",
      ancho: "100%",
      alto: "400",
      url: "https://www.youtube.com/embed/",
      video: "nkA-Tl4zv-E",
      borde: "0",
      pcompleta: null
    };
  },
  beforeUpdate() {},
  components: {
    DatePicker
  },
  props: {
    texto_introductorio: {
      type: String,
      default: null
    },
    /**
     * El parámetro caso, va permitir trabajar con diferentes variables del store
     * En el caso del formulario <informacion_general>, el valor va ser 2
     * El valor de 1 es el por defecto del componente
     */
    caso: {
      type: Number,
      default: 1
    },
    borrable: {
      type: Boolean,
      default: true
    },
    banderaSeguimiento: {
      type: Boolean,
      default: false
    },
    deshabilitado: {
      type: Boolean,
      default: false
    },
    verCompleto: {
      type: Boolean,
      default: false
    },
    banderaTarjetaMiniaturaExpandible: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.idFormulario = this.$store.getters.getIdFormularioOverlay;
    this.nombreFormulario = this.$store.getters.getNombreFormularioOverlay;
    this.variablesFormulario = this.$store.getters.getVariablesFormulariosOverlay;
    this.coleccion = this.$store.getters.getColeccionOverlay;
  },
  mounted() {},
  computed: {
    getVariablesFormularios() {
      let m_variablesFormularios = null;
      m_variablesFormularios = this.$store.getters
        .getVariablesFormulariosOverlay;
      self = this;
      if (m_variablesFormularios != null) {
        m_variablesFormularios.map(variable => {
          if (variable.nombre.length >= self.valorVariable) {
            self.valorVariable = variable.nombre.length;
            if (self.valorVariable >= 22 && self.valorVariable <= 30) {
              self.gridTemplate = "1fr 1fr";
            } else if (self.valorVariable > 30) {
              self.gridTemplate = "1fr";
            } else {
              self.gridTemplate = "1fr 1fr 1fr";
            }
          }
          if (self.verCompleto === true) {
            self.gridTemplate = "1fr 1fr 1fr";
          }
        });
      }
      return m_variablesFormularios;
    }
  },
  watch: {
    getVariablesFormularios() {}
  },
  methods: {
    construirArrayVariablesActualizar() {
      if (this.$refs.formOverlay.validate()) {
        const arrayActualizar = [];
        let m_variablesFormularios = this.$store.getters.getVariablesFormulariosOverlay;
        m_variablesFormularios.map(function(variable) {
          if (variable.valor != null) {
            if (variable.tipo == "numero") {
              const jsonActualizar = {
                nombre: variable.variable,
                valor: Number(variable.valor)
              };
              arrayActualizar.push(jsonActualizar);
            } else {
              const jsonActualizar = {
                nombre: variable.variable,
                valor: variable.valor
              };
              arrayActualizar.push(jsonActualizar);
            }
          }
        });
        this.$store.dispatch("setVariablesActualizadasOverlay", arrayActualizar);
        this.actualizarFormularioActual();
      }
    },
    async actualizarFormularioActual() {
      try {
        this.$store.dispatch("setCargando", true);
        let respuesta = null;
        respuesta = await actualizarFormulario(
          this.$store.getters.getIdVerEncuentrosOSeguimiento,
          this.$store.getters.getNombreEventoOverlay,
          this.$store.getters.getVariablesActualizadasOverlay,
          this.$store.getters.getColeccionOverlay,
          this.$store.state.provider_email
        );
        this.$store.dispatch("cambiarEstadoModal", true);
        this.$store.dispatch("cambiarMensajeModal", respuesta);
      } finally {
        this.$store.dispatch("setIdVerEncuentrosOSeguimiento", null);
        this.$store.dispatch("setVariablesFormulariosOverlay", []);
        this.$store.dispatch("setVariablesActualizadasOverlay", []);
        this.$store.dispatch("setNombreEventoOverlay", null);
        this.$emit("formularioActualizado");
        this.$store.dispatch("setCargando", false);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/sass/base/tipografia";
.contenedorTarjetaNuevasMomento {
  .titulo-global{
    padding: 5px;
    font-size: 16px;
  }
  height: 100%;
  width: 95%;
  transition: 0.3s;
  margin: 25px;
  .nombreRadioGroup {
    overflow-wrap: break-word;
    height: auto;
    text-align: left;
    font-size: 16px;
    line-height: 18px;
    min-width: 50%;
    color: $gris;
  }
  .tarjeta {
    // margin: 1.25vw auto 0% auto;
    margin-top: 15px;
    width: 100%;
    height: auto;
    padding: 1.25vw;
    position: sticky;
    border-radius: 8px;
    z-index: 0;
    .container {
      max-width: 1600px;
      #DivInformacionResumen {
        position: relative;
        min-width: 30% !important;
        margin: 0%;
        height: auto;
        padding: 2.2%;
        padding-left: 0;
        align-self: center;
      }
    }
  }
  .grid {
    display: grid;
    position: sticky;
  }

  .contenedorBotones {
    display: inline-flex;
    margin-bottom: 1.25vw;
    padding-left: 2.8%;
  }
  .botones {
    font-family: "Nunito", sans-serif;
    color: #646a6a;
    font-weight: bold;
    font-size: 18px;
    margin-right: 1.25vw;
    width: 100px;
    border-radius: 20px;
    height: 32px;
  }

  .botones:hover {
    background: #d4d1d163;
  }
  #botonEliminar {
    opacity: 0.5;
  }
  @media only screen and (max-width: 1666px) {
    .tarjeta .v-input {
      font-size: 15px;
      // @extend %texto-alternativo;
    }
  }
  @media only screen and (max-width: 1070px) {
   .contenedorBotones{
      display: flex;
      justify-content: center !important;
    }
    .botones {
      font-size: 14px;
      width: 80px;
      height: 25px;
    }
  }
  &.banderaSeguimiento {
    margin: 0;
    .tarjeta {
      width: 100%;
      padding: 0;
      box-shadow: none;
      .v-form .grid {
        padding: 5px;
        .v-input {
          @extend %texto-alternativo;
          // font-size: 15px;
        }
      }

      @media only screen and (max-width: 1666px) {
        .v-form .grid {
          grid-template-columns: 1fr !important;
          padding: 0;
          // .v-input {
          // @extend %texto-alternativo;
          // font-size: 12px;
          // }
        }
      }
    }
  }
  &.banderaTarjetaMiniaturaExpandible {
    margin: 0;
    width: 100%;
    .tarjeta {
      margin: 0;
      width: 100%;
      padding: 0;
      .v-form .grid {
        grid-template-columns: 1fr !important;
        padding: 5%;
      }
    }
    .contenedorBotones {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/VerTarjetasNuevasMomento/VerTarjetasNuevasMomento.vue